<template>
  <Modal
    :is-open="isOpen"
    icon="pencil"
    :title="$t('ui.crud.update', { item: $t('ui.common.note') })"
    description="You have 5 minutes to edit the note from the time it was created"
    :buttons="['close', 'ok']"
    close-text="Cancel"
    ok-text="Save"
    min-width="500"
    max-width="500"
    :has-unsaved-changes="hasUnsavedChanges"
    :is-confirming="isLoading"
    @close-modal="$emit('close')"
    @ok-modal="handleSave"
  >
    <div class="w-full">
      <TextArea
        :model-value="content ?? undefined"
        rows="6"
        auto-resize
        class="w-full"
        style="max-height: 150px !important"
        placeholder="Edit note..."
        has-speech-to-text
        :has-error="hasError"
        @update:model-value="$emit('update:content', $event)"
      />
      <InputError :has-error="hasError">{{ errorMessage }}</InputError>
    </div>
  </Modal>
</template>

<script setup lang="ts">
// components
import Modal from '@/components/modal/Modal.vue'
import TextArea from '@/components/forms/TextArea.vue'
import InputError from '@/components/forms/InputError.vue'

interface Props {
  isOpen: boolean
  isLoading: boolean
  hasUnsavedChanges: boolean
  content: string | null
  hasError: boolean
  errorMessage: string | null
}

defineProps<Props>()

const emit = defineEmits<{
  close: []
  save: []
  'update:content': [content: string | null]
}>()

/**
 * Handles the save event from the modal
 */
function handleSave(): void {
  emit('save')
}
</script>
